import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const CareerBucket = () => {
  const [careers, setCareers] = useState([]);

  useEffect(() => {
    fetch("https://tita.itrain.io/career/get")
      .then((response) => response.json())
      .then((data) => setCareers(data.career))
      .catch((error) => console.error("Error fetching careers:", error));
  }, []);

  return (
    <section className="service-section bg-grey padding">
      <div className="container">
        <div className="section-heading text-center mb-40">
          <h2>Step Into Your Future:<br />
            <span className="hl"> Careers at TITA Technologies</span>
          </h2>
        </div>
        <div className="row gy-lg-4 gy-4">
          {careers.map((career) => (
            <JobCard key={career._id} career={career} />
          ))}
        </div>
      </div>
    </section>
  );
};

const JobCard = ({ career }) => {
  const { title, desc, jobType, exp, _id } = career;
  const [showFullText, setShowFullText] = useState(false);

  const truncateText = (text, limit) => {
    return text.length > limit
      ? { truncated: true, content: text.substring(0, limit) + "..." }
      : { truncated: false, content: text };
  };

  const { truncated, content } = truncateText(desc, 200);

  return (
    <div className="col-lg-4 col-md-6">
      <div className="service-item">
        <div className="service-thumb">
          <img src="/assets/img/post-1.jpg" alt="thumb" />
        </div>
        <div className="service-content">
          <h3><a>{title}</a></h3>
          <p>
            {showFullText || !truncated ? desc : content}
            {truncated && (
              <span
                className="read-more-toggle"
                style={{ color: "blue", cursor: "pointer" }}
                onClick={() => setShowFullText(!showFullText)}
              >
                {showFullText ? " Show Less" : " Read More"}
              </span>
            )}
          </p>
          {jobType && <h4>Job Type: {jobType}</h4>}
          <h4>Experience: {exp}</h4>
          <Link to="/careerdetails-apply" className="read-more">
            Apply Now
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CareerBucket;
